const Coupon = {

    "coupon_code": "Coupon Code",
    "start_date": "Start Date",
    "start_time": "Start Time",
    "end_date": "End Date",
    "end_time": "End Time",
    "count": "Count",
    "user_per_count": "User Per Count",
    "discount_type": "Discount Type",
    "discount_value": "Discount Value",
    "paid_type": "Paid Type",
    "search": "Search",

    "coupon": "Coupon",
    "apply": "Apply",
    "applying": "Applying...",
    "remove": "Remove",
    "applied": "Coupon applied successfully",
    "applied_code": "Applied",
    "apply_failed": "Unable to apply coupon.",
    "total_amount": "Total Amount",
    "discount_amount": "Discount",

    "error_code": "Enter Coupon Code",
    "error_start_date": "Select Start Date",
    "error_start_time": "Select Start Time",
    "error_end_date": "Select End Date",
    "error_end_time": "End date and time must be after start",
    "error_count": "Enter Count",
    "error_count_min": "Count must be 0 or greater",
    "error_user_per_count": "Enter User Per Count",
    "error_user_per_count_min": "User Per Count must be 0 or greater",
    "error_discount_type": "Select Discount Type",
    "error_discount_value": "Enter Discount Value",
    "error_discount_percent": "Percentage cannot be more than 100",
    "error_paid_type": "Select Paid Type",

    "table_code": "COUPON CODE",
    "table_start": "START TIME",
    "table_end": "END TIME",
    "table_count": "COUNT",
    "table_user_per_count": "USER PER COUNT",
    "table_discount_type": "DISCOUNT TYPE",
    "table_discount_value": "DISCOUNT VALUE",
    "table_paid_type": "PAID TYPE",

}

export default Coupon;
